const constants = {
    LiveStatus: [
        {
            Name: 'Edit',
            Id: 1,
        },
        {
            Name: 'Live',
            Id: 2,
        },
    ],
    BridgeProductType: 14,
    ColorBaseTheme: [
        {
            Name: 'Light',
            Id: 1,
        },
        {
            Name: 'Dark',
            Id: 2,
        },
    ],
    FeaturedType: [
        {
            Name: 'Latest',
            Id: 1,
        },
        {
            Name: 'Featured',
            Id: 2,
        },
    ],
    ImageType: [
        {
            Name: 'Icon',
            Id: 0,
        },
        {
            Name: 'Header',
            Id: 1,
        },
        {
            Name: 'Launch',
            Id: 2,
        },
        {
            Name: 'Screenshot',
            Id: 3,
        },
        {
            Name: 'Logo',
            Id: 4,
            MinWidth: 372,
            MinHeight: 372,
        },
        {
            Name: 'Splash',
            Id: 5,
        },
        {
            Name: 'SplashBackground',
            Id: 6,
        },
        {
            Name: 'LaunchBackground',
            Id: 7,
        },
        {
            Name: 'ContentBanner',
            Id: 9,
            MinHeight: 720,
            MinWidth: 1280,
        },
        {
            Name: 'ContentImageWithText',
            Id: 10,
            MinHeight: 300,
            MinWidth: 300,
        },
    ],
    MenuStyle:
        [
            {
                Name: 'Bottom',
                Id: 1,
            },
            {
                Name: 'SlideOut',
                Id: 2,
            },
            {
                Name: 'Tiled',
                Id: 3,
            },
        ],
    ModuleType:
        [
            {
                Name: 'Discover',
                Id: 1,
                Group: 'Core',
            },
            {
                Name: 'Sermons',
                Id: 2,
                Group: 'Core',
            },
            {
                Name: 'Giving',
                Id: 3,
                Group: 'Core',
            },
            {
                Name: 'Events',
                Id: 4,
                Group: 'Core',
            },
            {
                Name: 'Contact',
                Id: 5,
                Group: 'Core',
            },
            {
                Name: 'LiveStreaming',
                Id: 6,
                Group: 'Hidden',
            },
            {
                Name: 'Check-In',
                Id: 7,
                Group: 'Chms',
            },
            {
                Name: 'Devotionals',
                Id: 8,
                Group: 'Core',
            },
            {
                Name: 'People',
                Id: 9,
                Group: 'Chms',
            },
            {
                Name: 'Calendar',
                Id: 10,
                Group: 'Core',
            },
            {
                Name: 'Groups',
                Id: 11,
                Group: 'Chms',
            },
            {
                Name: 'Interactions',
                Id: 12,
                Group: 'Chms',
            },
            {
              Name: 'Service Planning',
              Id: 13,
              Group: 'Core',
              IsUnity: true
            },
            {
                Name: 'StudioC',
                Id: 14,
                Group: 'Chms',
            },
            {
                Name: 'Attendance',
                Id: 15,
                Group: 'Chms',
            }
        ],
    MenuSubType:
        [
            {
                Name: 'Discover',
                Id: 1,
            },
            {
                Name: 'Sermons',
                Id: 2,
            },
            {
                Name: 'Giving',
                Id: 3,
            },
            {
                Name: 'Events',
                Id: 4,
            },
            {
                Name: 'Contact',
                Id: 5,
            },
            {
                Name: 'Check-in',
                Id: 7,
            },
            {
                Name: 'Devotionals',
                Id: 8,
            },
            {
                Name: 'People',
                Id: 9,
            },
            {
                Name: 'Calendar',
                Id: 10,
            },
            {
                Name: 'Groups',
                Id: 11,
            },
            {
                Name: 'Interactions',
                Id: 12,
            },
            {
                Name: 'Service Planning',
                Id: 13,
            },
            {
                Name: 'StudioC',
                Id: 14,
            },
            {
                Name: 'Attendance',
                Id: 15,
            },
        ],
    MediaType:
        [
            {
                Name: 'None',
                Id: 0,
            },
            {
                Name: 'YouTube',
                Id: 1,
            },
            {
                Name: 'Vimeo',
                Id: 2,
            },
            {
                Name: 'RSSPodcast',
                Id: 3,
            },
            {
                Name: 'Clover',
                Id: 4,
            },
            {
                Name: 'VimeoAPI',
                Id: 5,
            },
        ],
    ViewLayoutType:
        [
            {
                Name: 'List',
                Id: 1,
            },
            {
                Name: 'Grid',
                Id: 2,
            },
        ],
    ConfigErrorCode:
        [
            {
                ErrorCode: 'EXTERNAL_RESOURCE_ERROR',
                Link: '',
            },
            {
                ErrorCode: 'PUBLISH_FAILED',
                Link: '',
            },
            {
                ErrorCode: 'MODS_ERR_DIRECTORY_NOT_ENABLED',
                Link: 'modules/enable-modules',
            },
            {
                ErrorCode: 'MODS_ERR_DISCENABLEDSERMONOREVENTSNOT',
                Link: 'modules/enable-modules',
            },
            {
                ErrorCode: 'MODS_ERR_STREAMINGENABLEDSERMONORDISCNOT',
                Link: 'modules/enable-modules',
            },
            {
                ErrorCode: 'MODS_ERR_NOCONTACTFORM',
                Link: 'modules/contact',
            },
            {
                ErrorCode: 'MODS_ERR_NOFEATUREDEVENTFORM',
                Link: 'modules/events',
            },
            {
                ErrorCode: 'MODS_ERR_NOMODULESENABLED',
                Link: 'modules/enable-modules',
            },
            {
                ErrorCode: 'MODS_ERR_DISCENABLEDSHOWEXTRAFEAT',
                Link: 'modules/discover',
            },
            {
                ErrorCode: 'MODS_ERR_NOPRAYERREQFORM',
                Link: 'modules/contact',
            },
            {
                ErrorCode: 'MODS_ERR_NOSPECIALDONATIONFORM',
                Link: 'modules/giving',
            },
            {
                ErrorCode: 'MODS_ERR_NOGIVINGFORMSET',
                Link: 'modules/giving',
            },
            {
                ErrorCode: 'MODS_ERR_NOVALIDMEDIASOURCE',
                Link: 'modules/sermons',
            },
            {
                ErrorCode: 'MODS_ERR_NOTIFYBUTNULLNOTIFICATION',
                Link: 'integrations',
            },
            {
                ErrorCode: 'PCONF_ERR_NOCHURCHNAME',
                Link: 'general-info',
            },
            {
                ErrorCode: 'PCONF_ERR_NOVERSIONDESC',
                Link: 'general-info',
            },
            {
                ErrorCode: 'PCONF_ERR_NOVERSIONNAME',
                Link: 'general-info',
            }, {
                ErrorCode: 'PCONF_ERR_NOICON',
                Link: 'icons',
            },
            {
                ErrorCode: 'PCONF_ERR_NOLOGO',
                Link: 'logos',
            },
            {
                ErrorCode: 'PCONF_ERR_NOSPLASH',
                Link: 'splash',
            },
            {
                ErrorCode: 'PCONF_ERR_ADDRESSNOTVALID',
                Link: 'general-info',
            },
            {
                ErrorCode: 'MODS_ERR_NOVALIDCALENDARSOURCE',
                Link: 'modules/calendar',
            },
            {
                ErrorCode: 'MODS_ERR_CHMSFEEDONBUTNOTSELECTED',
                Link: 'modules/calendar',
            },
            {
                ErrorCode: 'MODS_ERR_CUSTOMICALURLINVALID',
                Link: 'modules/calendar',
            },
            {
                ErrorCode: 'PCONF_ERR_ADDRESSNOTCOMPLETE',
                Link: 'general-info',
            },
            {
                ErrorCode: 'MODS_ERR_PEOPLE_EMPTY',
                Link: 'modules/people',
            },
            {
                ErrorCode: 'MODS_ERR_GROUPS_EMPTY',
                Link: 'modules/groups',
            },
            {
                ErrorCode: 'PAGES_ERR_DESTINATION_FMS_NOTFOUND',
                Link: 'pages/pages',
            },
            {
                ErrorCode: 'PAGES_ERR_DESTINATION_PAGE_NOTFOUND',
                Link: 'pages/pages',
            },
            {
                ErrorCode: 'PAGES_ERR_DESTINATION_MODULE_DISABLED',
                Link: 'modules/enable-modules',
            },
            {
                ErrorCode: 'PAGE_ERR_DESTINATION_SELF',
                Link: 'pages/pages',
            },
            {
                ErrorCode: 'PAGES_ERR_MENUPAGEMISSING',
                Link: '',
            },
            {
                ErrorCode: 'PAGES_ERR_BLANKNAME',
                Link: 'pages/pages',
            },
            {
                ErrorCode: 'S_ERR_OLD_LIVESTREAMING_ACCOUNT',
                Link: 'integrations',
            },
        ],
    HelpResellerIds:
        [
            {
                ResellerName: 'easyTithe',
                ResellerCode: 51,
            },
            {
                ResellerName: 'ShelbyNext | Giving',
                ResellerCode: 52,
            },
            {
                ResellerName: 'Elexio Giving',
                ResellerCode: 50,
            },
            {
                ResellerName: 'Clover Give',
                ResellerCode: 53,
            },
            {
                ResellerName: 'Church Office Giving',
                ResellerCode: 60,
            },
            {
                ResellerName: 'e360 Giving',
                ResellerCode: 58,
            },
            {
                ResellerName: 'eGiving.com',
                ResellerCode: 56,
            },
            {
                ResellerName: 'FellowshipOne Giving',
                ResellerCode: 61,
            },
            {
                ResellerName: 'MoGiv',
                ResellerCode: 57,
            },
            {
                ResellerName: 'eGiving by NCS Services',
                ResellerCode: 55,
            },
            {
                ResellerName: 'ParishSOFT Giving',
                ResellerCode: 63,
            },
            {
                ResellerName: 'SimpleGive',
                ResellerCode: 54,
            },
            {
                ResellerName: 'SimpleChurch Giving',
                ResellerCode: 59,
            },
            {
                ResellerName: 'Kindrid',
                ResellerCode: 64,
            },
            {
                ResellerName: 'Sharefaith Giving',
                ResellerCode: 65,
            },
            {
                ResellerName: 'SiteOrganic Giving',
                ResellerCode: 66,
            },
            {
                ResellerName: 'Giving Help Desk',
                ResellerCode: 69,
            },
            {
                ResellerName: 'Sharefaith',
                ResellerCode: 65,
            },
            {
                ResellerName: 'Bridge Element Giving',
                ResellerCode: 70,
            },
            {
                ResellerName: 'E-zekiel Giving',
                ResellerCode: 71,
            },
            {
                ResellerName: 'Rocket Donations',
                ResellerCode: 72,
            },
            {
                ResellerName: 'Giving Base',
                ResellerCode: 73,
            },
            {
                ResellerName: 'Faith Highway Giving',
                ResellerCode: 74,
            },
            {
                ResellerName: 'Simple Tithe',
                ResellerCode: 75,
            },
            {
                ResellerName: 'eGive USA',
                ResellerCode: 76,
            },
            {
                ResellerName: 'Giving Kiosk',
                ResellerCode: 77,
            },
            {
                ResellerName: 'MinistryLinq',
                ResellerCode: 78,
            },
            {
                ResellerName: 'BlueFire Giving',
                ResellerCode: 79,
            },
            {
                ResellerName: 'EFTPlus',
                ResellerCode: 80,
            },
            {
                ResellerName: 'DonorDirect Giving',
                ResellerCode: 81,
            },
            {
                ResellerName: 'ChurchSquare',
                ResellerCode: 82,
            },
            {
                ResellerName: 'My Church Website Giving',
                ResellerCode: 83,
            },
            {
                ResellerName: 'Servant Keeper Giving',
                ResellerCode: 85,
            },
            {
                ResellerName: 'WeShare',
                ResellerCode: 87,
            },
            {
                ResellerName: 'Unity',
                ResellerCode: 89,
            },
        ],
    MenuType: [
        {
            Name: 'Module',
            Id: 1,
        },
        {
            Name: 'Pages',
            Id: 2,
        },
    ],
    ContentType: [
        {
            Name: 'Featured Sermon',
            Id: 101,
            Type: 'module',
        },
        {
            Name: 'Upcoming Events',
            Id: 100,
            Type: 'module',
        },
        {
            Name: 'Text',
            Id: 104,
            Type: 'content',
        },
        {
            Name: 'Banner',
            Id: 107,
            Type: 'content',
        },
        {
            Name: 'Video',
            Id: 103,
            Type: 'content',
        },
        {
            Name: 'Image & Text',
            Id: 105,
            Type: 'content',
        },
        {
            Name: 'LinkButton',
            Id: 106,
            Type: 'content',
        },
        {
            Name: 'Divider',
            Id: 102,
            Type: 'content',
        },
    ],
    StyleColors: {
        blue15: '#616B7D',
        grey35: '#6b6c7e',
        error2: '#C84040',
        successDark: '#3CA455',
        infoDark: '#176bfb',
        warningDark: '#E67337',
        white: '#FFFFFF',
    },
    IconList: [
        {
            value: 'address-book',
            label: 'Address, Information, Personal, Bio, User, Profile,Volunteer',
        },
        {
            value: 'bible',
            label: 'Book, Cross, Christian, Church, Fellowship, Study, Scripture, Holy, Faith, Devotional, Pray,Study,Teach,Lesson,Baptism',
        },
        {
            value: 'bolt',
            label: 'Lightning, Electric, Electricity, Activity, Dynamic, Buzz',
        },
        {
            value: 'book-alt',
            label: 'Book, Notebook, Log, Record, Page, Bible, Devotional, Study,Teach,Lesson',
        },
        {
            value: 'book-heart',
            label: 'Bible, Love, Heart, Book, Devotional, Serve,Pray,Study,Teach,Lesson,Volunteer',
        },
        {
            value: 'book-open',
            label: 'Book, Open, Bible, Notebook, Notes, History, Bulletin, Devotional, Study,Pray,Teach,Lesson',
        },
        {
            value: 'book-user',
            label: 'User, Book, Info, Personal, Details, Profile, Contact, Study,Teach,Lesson,Volunteer',
        },
        {
            value: 'book',
            label: 'Bible, Notebook, Script, Info, Contact, Address, Devotional, Study,Teach,Lesson',
        },
        {
            value: 'bookmark',
            label: 'Page, Favorite, Saved, Devotional, Study,Lesson',
        },
        {
            value: 'briefcase-medical',
            label: 'Medical, Briefcase, Cross, Health, Files, Work, Serve,Volunteer',
        },
        {
            value: 'briefcase',
            label: 'Files, Work, Serve,Volunteer',
        },
        {
            value: 'building',
            label: 'Work, School, Church, House, Office, Service',
        },
        {
            value: 'bullhorn',
            label: 'announcement, Alert, Megaphone, Broadcast',
        }, {
            value: 'calendar-alt',
            label: 'Calendar, Event, Date, Register, RSVP, Schedule, Volunteer,Service',
        },
        {
            value: 'calendar-check',
            label: 'Calendar, Event, Date, Check, Confirm, Register, RSVP, Schedule, Volunteer,Service',
        },
        {
            value: 'calendar-day',
            label: 'Calendar, Event, Date, Day, Register, RSVP, Schedule, Volunteer,Service',
        },
        {
            value: 'calendar',
            label: 'Calendar, Event, Date, Register, RSVP, Schedule, Volunteer,Service',
        },
        {
            value: 'check-circle',
            label: 'Checkmark, Success, Confirm, Done, Circle',
        },
        {
            value: 'church',
            label: 'Building, Sanctuary, Congregation, Worship, Christian, Pray, Parish, Cross, Steeple, Serve,Service,Baptism',
        },
        {
            value: 'cloud',
            label: 'Online, Data, Store',
        },
        {
            value: 'coins',
            label: 'Money, Currency, Serve,Giving, Tithe, Fund',
        },
        {
            value: 'comment-alt-dots',
            label: 'Comment, Chat, Message, More, Help, Dots, Ellipses, Ellipsis, Contact, Write',
        },
        {
            value: 'comment',
            label: 'Message, Chat, Help, Contact, Write',
        },
        {
            value: 'compass',
            label: 'Home, Place, Location, Discover, Serve',
        },
        {
            value: 'cross',
            label: 'Christian, Christ, Jesus, Church, Pray, Love, God, Serve,Study,Service,Baptism',
        },
        {
            value: 'door-open',
            label: 'Door, Log out, Sign out, Outreach, Serve,Service',
        },
        {
            value: 'envelope-open-dollar',
            label: 'Envelope, Message, Mail, Giving, Statement, Gift, Donation, Money, Pay, Open, Letter',
        },
        {
            value: 'envelope-open',
            label: 'Envelope, Mail, Message, Send, Receive, Letter',
        },
        {
            value: 'envelope',
            label: 'Mail, Message, Send, Receive, Letter',
        },
        {
            value: 'exclamation-circle',
            label: 'Error, Exclamation, Alert, Help, Attention',
        },
        {
            value: 'feather-alt',
            label: 'Feather, Write, Letter',
        },
        {
            value: 'file-alt',
            label: 'File, Page, Paper, Notes, Info, Contact, About, Write',
        },
        {
            value: 'file-user',
            label: 'File, Contact, Profile, Info, Address, Bio, Volunteer',
        },
        {
            value: 'file',
            label: 'Contact, Page, Notes, Info, Paper, About, Resources',
        },
        {
            value: 'fire-alt',
            label: 'Fire, Flame, New, Hot, Popular',
        },
        {
            value: 'fish',
            label: 'Christian, Faith, Hope, Religion, Church, Jesus, Serve,Pray,Baptism',
        },
        {
            value: 'flag',
            label: 'Banner, Country, Cause',
        },
        {
            value: 'folder',
            label: 'File, Info, Data, Contact, Save, Store, Resources',
        },
        {
            value: 'globe-americas',
            label: 'Globe, World, Earth, Planet, Space, Nation, Country, Serve,Volunteer',
        },
        {
            value: 'globe',
            label: 'Web, Data, Internet, Serve,Volunteer',
        },
        {
            value: 'guitar-electric',
            label: 'Guitar, Music, Worship, Ministry, Song, Ministry, Serve,Volunteer,Service',
        },
        {
            value: 'hand-holding-heart',
            label: 'Hand, Heart, Holding, Hold, Giving, Gift, Donation, Donate, Pay, Love, Serve,Volunteer',
        },
        {
            value: 'hand-holding-seedling',
            label: 'Hand, Seedling, Seed, Grow, Holding, Hold, Giving, Gift, Donation, Donate, Serve,Volunteer',
        },
        {
            value: 'hands-heart',
            label: 'Hand, Hands, Heart, Holding, Hold, Giving, Gift, Donation, Pay, Love, Serve,Volunteer',
        },
        {
            value: 'headphones',
            label: 'Listen, Earphones, Podcast, Sermons, Videos, Resources, Study,Live Stream',
        },
        {
            value: 'heart-circle',
            label: 'Heart, Circle, Love, Like, Giving, Give, Gift, Donate, Donation, Serve,Volunteer',
        },
        {
            value: 'heart-rate',
            label: 'Trending, Trend, Dynamic, Active, New, Discover, Serve,Volunteer',
        },
        {
            value: 'heart',
            label: 'Like, Love, Give, Giving, Gift, Donate, Donation, Serve,Volunteer',
        }, {
            value: 'heartbeat',
            label: 'Heart, New, Serve,Discover, Volunteer',
        },
        {
            value: 'history',
            label: 'Clock, Rewind, Previous, Revert, Time',
        }, {
            value: 'home-alt',
            label: 'Home, House, Building, Church, Class, Parish, Sanctuary, Shelter, Service',
        },
        {
            value: 'home-heart',
            label: 'Home, House, Heart, Love, Church, Parish, Sanctuary, Shelter, Serve,Service,Volunteer',
        },
        {
            value: 'image',
            label: 'Landscape, Photo, Picture, Media',
        },
        {
            value: 'info-circle',
            label: 'Info, About, Help, More',
        },
        {
            value: 'info-square',
            label: 'Info, About, Help, More, Square',
        },
        {
            value: 'layer-group',
            label: 'Layers, Group, Content, Assets, Stack',
        },
        {
            value: 'lightbulb',
            label: 'Light, Idea, New, Trending, Electric, Study,Lesson,Teach',
        },
        {
            value: 'link',
            label: 'Web, Webpage, Page, Site, Website',
        },
        {
            value: 'list-alt',
            label: 'List, Bullets, Point, Notes, Page, Info, About, Contact, Address',
        },
        {
            value: 'location-arrow',
            label: 'Place, Point, Directions, Address',
        },
        {
            value: 'location-circle',
            label: 'Place, Point, Address, Directions, Arrow',
        },
        {
            value: 'lock-open',
            label: 'Lock, Security, Protect',
        },
        {
            value: 'lock',
            label: 'Security, Protect',
        }, {
            value: 'map-marker-alt',
            label: 'Mark, Map, Location, Place, Directions, Address, Pin',
        }, {
            value: 'map-marker-check',
            label: 'Mark, Map, Location, Success, Check, Confirm, Place, Directions, Address, Pin',
        }, {
            value: 'map-marker-smile',
            label: 'Mark, Map, Location, Smiley, Success, Place, Directions, Address, Pin, Happy',
        }, {
            value: 'map-marker',
            label: 'Mark, Map, Location, Place, Directions, Address, Pin',
        }, {
            value: 'map-pin',
            label: 'Mark, Marker, Needle, Location, Place, Directions, Address',
        }, {
            value: 'map',
            label: 'Location, Place, Directions, Address, Contact',
        }, {
            value: 'medkit',
            label: 'Medicine, Medical, Aid, First Aid, Briefcase, Missions, Serve,Ministry, Cross, Volunteer',
        }, {
            value: 'microphone-alt',
            label: 'Broadcast, Sermons, Live Stream, Listen, Resources, Mic, Speak, Podcast',
        }, {
            value: 'microphone-stand',
            label: 'Broadcast, Sermons, Music, Worship, Live Stream, Listen, Speak, Mic, Podcast',
        }, {
            value: 'microphone',
            label: 'Mic, Broadcast, Live Stream, Sermons, Music, Worship, Live Stream, Listen, Speak, Podcast',
        }, {
            value: 'mobile',
            label: 'Phone, Contact, Profile, Info, App, iPhone, Android, Text, Messages',
        }, {
            value: 'money-check-edit',
            label: 'Pencil, Info, Gift, Giving, Donation, Donate, Pay, Fund',
        }, {
            value: 'mug-hot',
            label: 'Tea, Coffee, Water, Drink, Social, Shop, Study, Cup, Volunteer',
        }, {
            value: 'mug',
            label: 'Cup, Tea, Coffee, Shop, Social, Drink, Water, Study, Volunteer',
        }, {
            value: 'music',
            label: 'Notes, Worship, Sing, Volunteer,Service',
        }, {
            value: 'newspaper',
            label: 'Newsletter, News, Discover, Info, Trending, New, Home',
        }, {
            value: 'paper-plane',
            label: 'Message, Send, Deliver, Contact',
        }, {
            value: 'phone',
            label: 'Telephone, Call, Contact, Number, Info, Address, Mobile',
        }, {
            value: 'place-of-worship',
            label: 'Sanctuary, Building, Church, Hall, School, Steeple, Serve,Pray,Baptism,Service',
        }, {
            value: 'plug',
            label: 'Plugged, Electric, Engage, Serve, Ministry, Ministries, Serve,Volunteer',
        }, {
            value: 'podcast',
            label: 'Broadcast, Sermons, Live Stream, Listen, Resources, Teach,Lesson',
        }, {
            value: 'route',
            label: 'Directions, Location, Place, Contact, Map, Mark, Marker, Pin, Trip',
        }, {
            value: 'school',
            label: 'Clock, Time, Building, Town, Church, Schoolhouse, Serve,Teach,Lesson,Volunteer',
        }, {
            value: 'scroll',
            label: 'Content, Read, Events, Announcement, Info, Profile, Paper, Page, List, Discover',
        }, {
            value: 'seedling',
            label: 'Seed, Leaf, Leaves, Plant, Grow, Tree, New, Serve,Volunteer',
        }, {
            value: 'smile',
            label: 'Face, Happy, Smiley, Give, Giving, Gift,Serve, Volunteer',
        }, {
            value: 'sparkles',
            label: 'Stars, New, Discover, Home',
        }, {
            value: 'star-christmas',
            label: 'Star, Sparkles, Christmas, New, Home, Discover, Location',
        }, {
            value: 'star',
            label: 'New, Discover, Home',
        }, {
            value: 'stars',
            label: 'New, Discover, Home',
        }, {
            value: 'tennis-ball',
            label: 'Youth, Sports, Events, Ball',
        }, {
            value: 'tree-christmas',
            label: 'Holiday, Season, Advent',
        }, {
            value: 'tv',
            label: 'Television, Watch, Stream, Live, Videos, Sermons, Media, Screen, Resources',
        }, {
            value: 'user-alt',
            label: 'Profile, Individual, Info, Account, People, Person, Congregant, Group, Volunteer',
        }, {
            value: 'user-circle',
            label: 'Profile, Individual, Info, Account, People, Person, Congregant, Group, Contact, Volunteer',
        }, {
            value: 'user-friends',
            label: 'Account, Profile, People, Group, Congregant, People, Info, Contact, Volunteer',
        }, {
            value: 'user',
            label: 'Profile, Individual, Info, Account, People, Person, Congregant, Group, Contact, Volunteer',
        }, {
            value: 'users-medical',
            label: 'Profile, Add, Individual, Info, Account, People, Group, Person, Family, Contact, Congregant, Aid, Volunteer',
        }, {
            value: 'users',
            label: 'Profile, Individual, Info, Account, People, Person, Congregant, Group, Congregation, Contact, Volunteer',
        }, {
            value: 'video',
            label: 'Live, Stream, Watch, Sermons, Resources, Media, Record, Service',
        }, {
            value: 'volume-down',
            label: 'Speaker, Listen, Sermons, Announce, Broadcast, Resources, Contact, Message, Media, Live, Stream',
        }, {
            value: 'wallet',
            label: 'Payment, Money, Give, Giving, Gift, Donate, Donations',
        }, {
            value: 'waveform-path',
            label: 'Sound, New, Discover, Hot, Home, Buzz, News',
        }, {
            value: 'waveform',
            label: 'Sound, New, Discover, Hot, Home, Buzz, News',
        }, {
            value: 'window-alt',
            label: 'Web, Webpage, Page, Screen, Website, Computer, Media, Internet',
        },
        {
            value: 'people-arrows',
            label: 'Interactions',
        },
        {
            value: 'map-marker-alt',
            label: 'Check-in'
        },
        {
          value: 'clipboard-list-check',
          label: 'Service Planning',
        },
        {
          value: 'school',
          label: 'StudioC',
        },
        {
          value: 'users',
          label: 'Attendance',
        }
    ],
};
export default constants;
